import { Directive, AfterViewInit, inject, DestroyRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
    selector: '[appDecimalOnly]',
    standalone: false
})
export class DecimalOnlyDirective implements AfterViewInit {
  @Input('appDecimalOnly') enabled?: boolean = false;
  private ngControl = inject(NgControl);
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    if (this.enabled) {
      this.ngControl.valueChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: string) => {
        let initialValue = value;
        if (typeof value === 'string') {
          initialValue = value.replace(/[^0-9.]/g, '')        // Only numbers and periods allowed
                              .replace(/^(\.)/, '')           // Remove the dot at the beginning
                              .replace(/(\..*?)\./g, '$1');   // Block multiple dots
        }
        if (value !== initialValue) {
          this.ngControl.control?.setValue(initialValue, { emitEvent: false });
        }
      });
    }
  }
}